<template>
  <v-container class="mt-10">
    <a class="anchor" id="sponsors"></a>
    <div class="col text-center">
      <h2 class="text-center text-uppercase">
        <i class="fas fa-square"></i>
        {{ pageSettings.sponsorsTitle }}
      </h2>
    </div>
    <p
      class="text-justify"
      v-html="getRichTextString(pageSettings.sponsorsText, false)"
      v-if="pageSettings.sponsorsText"
    ></p>
    <v-row align="center" justify="center">
      <v-col
        v-for="sponsor in sponsors"
        :key="sponsor.id"
        cols="12"
        md="6"
        lg="4"
      >
        <v-card class="pa-2 pt-6">
          <v-img
            :src="sponsor.image._urls['one-half']"
            height="60px"
            contain
          ></v-img>
          <v-card-actions>
            <v-btn
              v-if="sponsor.videos && sponsor.videos.length > 0"
              icon
              @click="sponsor.show = !sponsor.show"
            >
              <v-icon>{{
                sponsor.show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="sponsor.show = !sponsor.show"
              v-if="sponsor.videos && sponsor.videos.length > 0"
            >
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition
            v-if="sponsor.videos && sponsor.videos.length > 0"
            class="ma-5"
          >
            <div v-show="sponsor.show" class="video-container">
              <v-carousel
                height="100%"
                :show-arrows="sponsor.videos.length > 1"
                :hide-delimiters="
                  sponsor.videos.length <= 1 ||
                    sponsor.videos.find((video) =>
                      video.video.startsWith('https://player.vimeo.com')
                    )
                "
                show-arrows-on-hover
                v-model="sponsor.currentVideo"
              >
                <v-carousel-item
                  v-for="(video, index) in sponsor.videos"
                  :key="video.id"
                >
                  <iframe
                    v-if="sponsor.show && index === sponsor.currentVideo"
                    class="embedded-video"
                    :src="embeddedVideoUrl(video.video)"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen="allowfullscreen"
                  ></iframe>
                </v-carousel-item>
              </v-carousel>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { sponsorGroupResource } from "./../api/resources";

export default {
  async mounted() {
    let allSponsors = [];
    if (this.pageSettings.sponsorGroupsIds) {
      for (const sponsorGroupId of this.pageSettings.sponsorGroupsIds) {
        const sponsors = (
          await sponsorGroupResource.get(sponsorGroupId, {
            headers: {
              "x-xsrf-token": this.$cookies.get("oegg-cms.csrf"),
            },
          })
        ).data.sponsors.filter((sponsor) => sponsor.approved);
        allSponsors = allSponsors.concat(
          sponsors.map((sponsor) => {
            return { ...sponsor, show: false, currentVideo: 0 };
          })
        );
      }
    }
    // gather exhibitors for videos
    let exhibitors = [];
    if (this.pageSettings.sponsorGroupsExhibitionIds) {
      for (const sponsorGroupId of this.pageSettings
        .sponsorGroupsExhibitionIds) {
        const sponsors = (
          await sponsorGroupResource.get(sponsorGroupId, {
            headers: {
              "x-xsrf-token": this.$cookies.get("oegg-cms.csrf"),
            },
          })
        ).data.sponsors
          .filter((sponsor) => sponsor.approved)
          .map((sponsor) => {
            return { ...sponsor, sponsorGroupId };
          });
        exhibitors = exhibitors.concat(sponsors);
      }
    }
    const uniqueSponsors = [];
    for (const sponsor of allSponsors) {
      let add = true;
      for (const existingSponsor of uniqueSponsors) {
        if (!existingSponsor.url) {
          continue;
        }
        if (existingSponsor.url.startsWith(sponsor.url)) {
          add = false;
          if (
            (!sponsor.videos || sponsor.videos.length === 0) &&
            existingSponsor.videos &&
            existingSponsor.videos.length > 0
          ) {
            sponsor.videos = existingSponsor.videos;
          }
        }
      }
      if (add) {
        if (!sponsor.videos || sponsor.videos.length === 0) {
          for (const exhibitor of exhibitors) {
            if (!exhibitor.url) {
              continue;
            }
            if (
              exhibitor.url.startsWith(sponsor.url) &&
              exhibitor.videos &&
              exhibitor.videos.length > 0
            ) {
              sponsor.videos = exhibitor.videos;
              break;
            }
          }
        }
        uniqueSponsors.push(sponsor);
      }
    }
    const sponsorsWithVideos = uniqueSponsors.filter(
      (sponsor) => sponsor.videos && sponsor.videos.length > 0
    );
    const otherSponsors = uniqueSponsors.filter(
      (sponsor) => !sponsor.videos || sponsor.videos.length === 0
    );
    this.sponsors = [
      ...sponsorsWithVideos.sort(() => Math.random() - 0.5),
      ...otherSponsors.sort(() => Math.random() - 0.5),
    ];
  },
  data: () => ({
    sponsors: [],
  }),
  computed: {
    ...mapGetters(["pageSettings", "embeddedVideoUrl"]),
  },
  methods: {
    getRichTextString(richText, stripHtmlTags) {
      let htmlText = "";
      if (!richText || !richText.items) {
        return htmlText;
      }
      htmlText = richText.items.map((element) => element.content).join();
      if (stripHtmlTags) {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = htmlText;
        return tmp.textContent || tmp.innerText || "";
      }
      return htmlText;
    },
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  width: 100%;
  height: 0;
}
.video-container iframe,
.video-container > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
